<div class="ds-notification-warning"
     *ngIf="!!userSubscription?.paused && userSubscription?.status !== userSubscriptionStatus.expired &&
             userSubscription.status !== userSubscriptionStatus.failed &&
             !userSubscription.isExpired && !userSubscription.appsumoIsExpired">
    <div>
        <i class="db-icon db-icon-ds-exclamation-bg"></i>
        <span class="warn-message"><b>Your account is successfully paused.</b> To continue using {{ companyInfo?.branding?.company_name || companyInfo?.agency?.name}}, please unpause your account.</span>
    </div>
</div>
<ng-container *ngIf="userSubscription">
    @if (!isAiDemoUser && userSubscription.subscriptionId === Config.defaultStarterPlanId) {
        <db-trial-subscription-plan [userLocalStorage]="userLocalStorage" [userSubscription]="userSubscription"
                                    (onUpgradeClick)="showPricingDialog()"></db-trial-subscription-plan>
    } @else {
        <div class="subscription-plan db-page-content"
             *ngIf="!userSubscription?.plan?.shortFeatures?.newPlan; else alternativePlan">
            <div class="subscription-plan__summary">
                <div class="subscription-plan__summary-main-block">
                    <div class="db-subscription-body">
                        <div class="db-plan-info" *ngIf="userSubscription?.plan">
                            <db-plan-label
                                    *ngIf="userSubscription?.type !== UserSubscriptionType.BOOSTER && !userSubscription?.trialBoosterClient"
                                    [user]="user" [userSubscription]="userSubscription"
                                    [_trialDeleteDay]="_trialDeleteDay" [trialDeleteDay]="trialDeleteDay"
                                    [userSubscriptionStorage]="userSubscriptionStorage"
                                    [userSubscriptionVisits]="userSubscriptionVisits"></db-plan-label>
                            <div class="db-ai-booster-plan-list">
                                <db-plan-label-booster
                                        *ngIf="userSubscription?.trialBoosterClient || userSubscription?.boosterProClient"
                                        [_trialDeleteDay]="_trialDeleteDay" [user]="user"
                                        [trialDeleteDay]="trialDeleteDay"
                                        [userSubscriptionStorage]="userSubscriptionStorage"
                                        [userSubscriptionVisits]="userSubscriptionVisits"></db-plan-label-booster>
                            </div>
                            <db-cdn-info
                                    *ngIf="(userSubscription?.plan?.additionalDomainCount || userSubscription?.plan?.additionalCDNCount) && (userSubscription?.platformPaidClient)"
                                    [userSubscriptionStorage]="userSubscriptionStorage"
                                    [userSubscriptionVisits]="userSubscriptionVisits"
                                    [userSubscriptionStatus]="userSubscriptionStatus"></db-cdn-info>
                            <db-billing-info
                                    *ngIf="!userSubscription?.trialBoosterClient && userSubscription?.type !== UserSubscriptionType.BOOSTER "
                                    [userSubscription]="userSubscription" [user]="user"></db-billing-info>
                        </div>
                    </div>
                    <div class="db-subscription-footer">

                        <db-payment-button [userSubscription]="userSubscription"
                                           [upgradeSubscription]="upgradeSubscription"
                                           [campaignInfo]="campaignInfo"
                                           [user]="user" [aiStarterAnnual]="aiStarterAnnual"
                                           [trialDeleteDay]="trialDeleteDay"
                                           (activateAddOns)="activateUserSubscription()"
                                           *ngIf="userSubscription?.trialBoosterClient || userSubscription?.type === UserSubscriptionType.BOOSTER"></db-payment-button>
                        <db-billing-info *ngIf="userSubscription?.type === UserSubscriptionType.BOOSTER "
                                         [userSubscription]="userSubscription" [user]="user"></db-billing-info>

                        <db-payment-button [userSubscription]="userSubscription"
                                           [upgradeSubscription]="upgradeSubscription"
                                           [user]="user" [aiStarterAnnual]="aiStarterAnnual"
                                           [trialDeleteDay]="trialDeleteDay"
                                           (activateAddOns)="activateUserSubscription()"
                                           *ngIf="!userSubscription?.trialBoosterClient && userSubscription?.type !== UserSubscriptionType.BOOSTER"></db-payment-button>
                    </div>
                </div>
            </div>
        </div>
        <ng-template #alternativePlan>
            <db-alternative-subscription-plan
                    class="subscription-plan"
                    (unpause)="renewSubscription($event)"
                    (activateUserSubscription)="activateUserSubscription()"
                    (retryUserSubscription)="renewUserSubscription($event)"
                    (onAddPaymentMethod)="addPaymentMethod($event)"
                    [activationClicked]="activateClicked"
                    (cancelSub)="cancelUserSubscription()"
                    (renewFromDomainBanner)="renewUserSubscription(userSubscription, true, true)"
                    [paymentMethods]="paymentMethods"
                    [user]="user"
                    [currentWorkspaceRole]="currentWorkspaceRole"
                    [hasUpgrade]="!!hasUpgrade"
                    [annualPrice]="annualPrice"
                    [isDemoUser]="isDemoUser"
                    [userSubscription]="userSubscription">
                <ds-billing-info [userSubscription]="userSubscription"
                                 [annualSubscription]="annualSubscription"
                                 [monthlyPrice]="monthlyPrice"
                                 [annualPriceForCurrent]="annualPriceForCurrent"
                                 [user]="user" [annualPrice]="annualPrice"
                                 [isTier1Country]="isTier1Country || englishCountries"></ds-billing-info>
                <div class="db-actions-wrap">
                    @if (userSubscription?.stripeSbcrstatus === 'active') {
                        <div class="db-actions-wrap-enterprise">
                            {{ 'text_cancelSubscriptionText' | dbText}}<a class="db-link"
                                                                 (click)="cancelUserSubscription()"><span>{{ 'text_clickHere' | dbText}}</span></a>
                        </div>
                    } @else if (userSubscription?.stripeSbcrstatus === 'canceled' && userSubscription?.isExpired && userSubscription?.platformPaidClient) {
                        <div class="db-actions-wrap-enterprise">
                            <a class="db-link renew" (click)="renewSubscription()" *ngIf="!activateClicked">
                                <span>{{ 'text_toggleRenewExpired' | dbText}}</span>
                            </a>
                        </div>
                    } @else if (userSubscription?.stripeSbcrstatus === 'paused') {
                        <div class="db-actions-wrap-enterprise">
                            <a class="db-link"
                               *ngIf="userSubscription?.paymentType !== 'card' &&
                   !userSubscription?.canReactivate; else !!userSubscription?.paused ? renew : activate"
                               (click)="addPaymentMethod(false)">
                                <span>{{ 'text_activateSubscription' | dbText }}</span>
                            </a>
                            <ng-template #activate>
                                <a class="db-link activate" (click)="activateUserSubscription()">
                                    <span>{{ 'text_activateSubscription' | dbText }}</span>
                                </a>
                            </ng-template>
                            <ng-template #renew>
                                <a class="db-link renew" (click)="renewSubscription()" *ngIf="!activateClicked">
                                    <span>{{ 'text_unpauseSubscription' | dbText }}</span>
                                </a>
                            </ng-template>
                        </div>
                    }
                </div>
                <ds-payment-button [userSubscription]="userSubscription"
                                   [campaignInfo]="campaignInfo"
                                   [upgradeSubscription]="upgradeSubscription"
                                   [user]="user"
                                   [aiStarterAnnual]="aiStarterAnnual"
                                   [trialDeleteDay]="trialDeleteDay"
                                   [demoUser]="isDemoUser"
                                   (activateAddOns)="activateUserSubscription()">
                </ds-payment-button>
            </db-alternative-subscription-plan>
        </ng-template>
    }

</ng-container>
<db-loading-screen [ngClass]="{'hidden':!loading}"></db-loading-screen>
